module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row m-b-15"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "box-body form-left"
  }, [_c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("活動名稱(後台)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.menuName),
      expression: "menuName"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.menuName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.menuName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("活動名稱(前端)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.menuName),
      expression: "menuName"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.menuName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.menuName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("活動說明(後台)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.menuId),
      expression: "menuId"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.menuId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.menuId = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("活動說明(前端)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.menuId),
      expression: "menuId"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.menuId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.menuId = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("活動順序")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.menuId),
      expression: "menuId"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.menuId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.menuId = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "box-body form-right"
  }, [_c('div', [_c('div', {
    staticClass: "input-group cr-schedule"
  }, [_vm._m(0), _vm._v(" "), _c('date-time-picker', {
    attrs: {
      "date": _vm.menuTime.start,
      "option": _vm.timeoption,
      "limit": _vm.startLimit
    }
  })], 1), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group cr-schedule"
  }, [_vm._m(1), _vm._v(" "), _c('date-time-picker', {
    attrs: {
      "date": _vm.menuTime.end,
      "option": _vm.timeoption,
      "limit": _vm.endLimit
    }
  })], 1), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                  會員限制\n                ")]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "options": _vm.memberType,
      "multiple": true,
      "close-on-select": false,
      "clear-on-select": false,
      "preserve-search": true,
      "placeholder": "會員限制",
      "label": "label",
      "track-by": "label"
    },
    model: {
      value: (_vm.memberLimit),
      callback: function($$v) {
        _vm.memberLimit = $$v
      },
      expression: "memberLimit"
    }
  })], 1), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 p-sm-10-p m-x-10 form-left"
  }, [_c('h5', [_vm._v("參與店家")]), _vm._v(" "), _c('muti-select-two', {
    attrs: {
      "setting": _vm.addStoresSetting
    }
  })], 1), _vm._v(" "), _c('hr', {
    staticClass: "box-body col-xs-12"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 p-sm-10-p m-x-10 form-left"
  }, [_vm._m(2), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "data-target": "#couponRegisterModal",
      "data-toggle": "modal"
    },
    on: {
      "click": function($event) {
        return _vm.addCoupon()
      }
    }
  }, [_vm._v(" + 贈送優惠券")]), _vm._v(" "), _c('multiselect', {
    staticStyle: {
      "width": "calc(100% - 130px)",
      "display": "inline-block"
    },
    attrs: {
      "options": _vm.otherCouponList,
      "multiple": true,
      "close-on-select": false,
      "clear-on-select": false,
      "preserve-search": true,
      "placeholder": "行銷下其他優惠券",
      "label": "label",
      "track-by": "label"
    },
    on: {
      "select": _vm.changeOtherCoupon,
      "remove": _vm.removeOtherCoupon
    },
    model: {
      value: (_vm.otherCoupon),
      callback: function($$v) {
        _vm.otherCoupon = $$v
      },
      expression: "otherCoupon"
    }
  }), _vm._v(" "), _c('br')], 1), _vm._v(" "), _vm._l((_vm.couponList), function(coupon, index) {
    return _c('div', [_c('div', {
      staticClass: "card m-y-1 pull-left m-y-10 c-pointer",
      staticStyle: {
        "width": "calc(100% - 80px)"
      },
      attrs: {
        "data-target": "#couponRegisterModal",
        "data-toggle": "modal"
      },
      on: {
        "click": function($event) {
          return _vm.clickCoupon()
        }
      }
    }, [_vm._m(3, true), _vm._v(" "), _vm._m(4, true)]), _vm._v(" "), (!coupon.code) ? _c('div', {
      staticClass: "coupon-edit-block pull-left"
    }, [(_vm.couponList.length > 1) ? _c('button', {
      staticClass: "btn btn-danger",
      on: {
        "click": function($event) {
          return _vm.couponList.splice(index, 1)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })]) : _vm._e(), _vm._v(" "), (_vm.couponList.length > 1) ? _c('br') : _vm._e(), _vm._v(" "), _vm._m(5, true)]) : _vm._e()])
  })], 2)])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.crSchedule
    }
  }, [_vm._v("\n      新增\n    ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-fail",
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("\n      取消\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "couponRegisterModal",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog choose-modal"
  }, [_c('div', {
    staticClass: "modal-content pull-left"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "modal-body text-left pull-left"
  }, [_c('div', {
    staticClass: "pull-left"
  }, [_c('div', {
    staticClass: "card m-y-1 pull-left w-100-p m-y-10 c-pointer"
  }, [_c('div', {
    staticClass: "coupon-left p-10"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.useType,
      "label": "label",
      "searchable": false,
      "allow-empty": true,
      "close-on-select": true,
      "placeholder": "優惠券型態",
      "show-labels": false
    },
    model: {
      value: (_vm.coupon.useType),
      callback: function($$v) {
        _vm.$set(_vm.coupon, "useType", $$v)
      },
      expression: "coupon.useType"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "placeholder": "優惠券名稱"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('textarea', {
    staticClass: "form-control",
    attrs: {
      "placeholder": "優惠券描述"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('textarea', {
    staticClass: "form-control",
    attrs: {
      "placeholder": "備註"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('h5', {
    staticClass: "text-light-gray m-t-0"
  }, [_vm._v("\n                  使用期限    \n                ")]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "options": _vm.deadType,
      "label": "label",
      "searchable": false,
      "allow-empty": false,
      "close-on-select": true,
      "placeholder": "過期時間種類",
      "show-labels": false
    },
    model: {
      value: (_vm.coupon.type),
      callback: function($$v) {
        _vm.$set(_vm.coupon, "type", $$v)
      },
      expression: "coupon.type"
    }
  }), _vm._v(" "), (_vm.coupon.type.value === 1) ? _c('div', {
    staticClass: "m-t-10 inline-block m-r-10"
  }, [_vm._v("\n                  開始："), _c('date-time-picker', {
    attrs: {
      "date": _vm.menuTime.start,
      "option": _vm.timeoption,
      "limit": _vm.startLimit
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.coupon.type.value === 1 || _vm.coupon.type.value === 2) ? _c('div', {
    staticClass: "m-t-10 inline-block"
  }, [_vm._v("\n                  結束："), _c('date-time-picker', {
    attrs: {
      "date": _vm.menuTime.end,
      "option": _vm.timeoption,
      "limit": _vm.endLimit
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.coupon.type.value === 3) ? _c('div', {
    staticClass: "m-t-10"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "placeholder": "幾天後到期"
    }
  })]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "coupon-right p-10"
  }, [_c('div', [_c('multiselect', {
    attrs: {
      "options": _vm.priceType,
      "label": "label",
      "searchable": false,
      "allow-empty": false,
      "close-on-select": true,
      "placeholder": "優惠券稅制",
      "show-labels": false
    },
    model: {
      value: (_vm.coupon.price_type),
      callback: function($$v) {
        _vm.$set(_vm.coupon, "price_type", $$v)
      },
      expression: "coupon.price_type"
    }
  }), _vm._v(" "), _c('br')], 1), _vm._v(" "), _c('div', [_c('multiselect', {
    attrs: {
      "options": _vm.discountType,
      "label": "label",
      "searchable": false,
      "allow-empty": false,
      "close-on-select": true,
      "placeholder": "優惠券稅制",
      "show-labels": false
    },
    model: {
      value: (_vm.coupon.discount_type),
      callback: function($$v) {
        _vm.$set(_vm.coupon, "discount_type", $$v)
      },
      expression: "coupon.discount_type"
    }
  }), _vm._v(" "), _c('br')], 1), _vm._v(" "), _vm._m(7)])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "pull-left w-100-p"
  }, [_c('hr'), _vm._v(" "), _c('br'), _vm._v(" "), _c('multiselect', {
    attrs: {
      "options": _vm.couponSetting,
      "label": "label",
      "searchable": false,
      "allow-empty": false,
      "close-on-select": true,
      "placeholder": "優惠券稅制",
      "show-labels": false
    },
    model: {
      value: (_vm.coupon.setting),
      callback: function($$v) {
        _vm.$set(_vm.coupon, "setting", $$v)
      },
      expression: "coupon.setting"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pull-left m-t-20"
  }, [_c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("個人訂單最低消費金額")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.menuName),
      expression: "menuName"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.menuName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.menuName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("個人訂單最低消費商品數")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.menuName),
      expression: "menuName"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.menuName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.menuName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("最大使用數量")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.menuName),
      expression: "menuName"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.menuName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.menuName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), (_vm.coupon.setting.value === 1) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("商品限制最低單價")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.menuName),
      expression: "menuName"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.menuName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.menuName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.coupon.setting.value === 1 || _vm.coupon.setting.value === 2) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("每商品限用張數")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.menuName),
      expression: "menuName"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.menuName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.menuName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.coupon.setting.value === 3) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("滿多少的總金額數值")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.menuName),
      expression: "menuName"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.menuName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.menuName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.coupon.setting.value === 3) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("每達到金額限用的張數")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.menuName),
      expression: "menuName"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.menuName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.menuName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.coupon.setting.value === 1 || _vm.coupon.setting.value === 3) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("排除商品")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.menuName),
      expression: "menuName"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.menuName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.menuName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.coupon.setting.value === 2) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("指定消費商品")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.menuName),
      expression: "menuName"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.menuName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.menuName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group text-left"
  }, [_c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orderType),
      expression: "orderType"
    }],
    attrs: {
      "type": "radio",
      "name": "iconOption",
      "value": "0"
    },
    domProps: {
      "checked": _vm._q(_vm.orderType, "0")
    },
    on: {
      "change": function($event) {
        _vm.orderType = "0"
      }
    }
  }), _vm._v("無限制\n                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orderType),
      expression: "orderType"
    }],
    attrs: {
      "type": "radio",
      "name": "iconOption",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.orderType, "1")
    },
    on: {
      "change": function($event) {
        _vm.orderType = "1"
      }
    }
  }), _vm._v("一般單\n                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orderType),
      expression: "orderType"
    }],
    attrs: {
      "type": "radio",
      "name": "iconOption",
      "value": "2"
    },
    domProps: {
      "checked": _vm._q(_vm.orderType, "2")
    },
    on: {
      "change": function($event) {
        _vm.orderType = "2"
      }
    }
  }), _vm._v("團購單\n                        ")])])])]), _vm._v(" "), _c('br')])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("活動開始時間\n                        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("活動結束時間\n                ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h4', [_vm._v("贈送規則")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coupon-left p-10"
  }, [_c('h4', [_vm._v("Nidin優惠券")]), _vm._v(" "), _c('h5', [_vm._v("優惠券描述(備註)")]), _vm._v(" "), _c('h5', [_c('i', {
    staticClass: "fa fa-clock"
  }), _vm._v("到期：2018-12-29 12:00 ~ 2019-12-22 12:00")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coupon-right p-10"
  }, [_c('div', {
    staticClass: "v-middle"
  }, [_vm._v("\n                    $10\n                  ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-default m-t-5"
  }, [_c('i', {
    staticClass: "fa fa-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header pull-left w-100-p"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title text-left"
  }, [_vm._v("優惠券設定")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('input', {
    staticClass: "form-control",
    attrs: {
      "placeholder": "面額"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("可使用優惠券的訂單類型\n                ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-150c9a6a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Marketing/Temp/ActivityRegisterForm.vue
// module id = 2329
// module chunks = 1